import { Component } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { Observable } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})

export class AppComponent {
  title = 'vecpt-admin';
  events: string[] = [];
  opened: boolean = true;
  hasBackdrop = false;
  mode = 'side';
  public loggedIn: Observable<boolean>;
  public urlSeg:string='';

  constructor(
    private authService: AuthenticationService,
    private router:Router
  ) {
    this.loggedIn = authService.loggedIn;
    if(window.innerWidth<1200){
      this.opened = false;
      this.hasBackdrop = true;
      this.mode = 'over';
    }

    this.router.events.subscribe((event: NavigationEnd) => {

      if(window.innerWidth<1200){
        this.opened = false;

      }
      if(event instanceof NavigationEnd) {
        this.urlSeg=event.url.split('/')[1] || '';
      }
    });
  }

  onResize(event){
    event.target.innerWidth;
    if(event.target.innerWidth<1200){
      this.opened = false;
      this.hasBackdrop = true;
      this.mode = 'over';
    }
    else{
      this.opened = true;
      this.hasBackdrop = false;
      this.mode = 'side';
    }
  }

  toggleMenu(){
    if(this.opened){ this.opened = false}
    else {this.opened = true;}
  }

  logout(){
    this.authService.logout();
    this.router.navigate(['/login']);
  }

}
